import { render, staticRenderFns } from "./SkillBalanceDisplay.vue?vue&type=template&id=6c0e1975&"
import script from "./SkillBalanceDisplay.vue?vue&type=script&lang=ts&"
export * from "./SkillBalanceDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SkillBalanceDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports